import { render, staticRenderFns } from "./USC_AT21_ONLY_2.vue?vue&type=template&id=19638b58"
import script from "./USC_AT21_ONLY_2.vue?vue&type=script&lang=js"
export * from "./USC_AT21_ONLY_2.vue?vue&type=script&lang=js"
import style0 from "./USC_AT21_ONLY_2.vue?vue&type=style&index=0&id=19638b58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports